import script from "./botao-menu-superior.vue?vue&type=script&setup=true&lang=js"
export * from "./botao-menu-superior.vue?vue&type=script&setup=true&lang=js"

import "./botao-menu-superior.vue?vue&type=style&index=0&id=151ba6ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-151ba6ca"]])

export default __exports__